import React from "react";
import "./tag.less";

interface TagInterface { 
   children?: React.ReactNode,
   color?: string,
   className?: string,
   id?: string,
   style?: React.CSSProperties
}

export const Tag: React.FC<TagInterface> = ({
   children,
   color,
   className = "defult-color",
   id,
   style = {}
}) => {
   const setColor: object = {
      backgroundColor: color,
      borderColor: color
   };

   return (
      <span
         className={"bp2-tag-component " + className}
         id={id}
         style={Object.assign(style, setColor)}
      >
         {children}
      </span>
   );
};

export default Tag;